<template>
  <div v-if="track.videos.length" class="video-section">
    <div class="title">
      <h3>{{ track.title }}</h3>
    </div>
    <div class="row">
    <!-- <div class="card-list"> -->
      <template v-for="(item, index) in track.videos">
        <div class="col-md-6 col-lg-3">
          <videoCard v-bind:key="index" :trackIndex="trackIndex" :itemIndex="index" :item="item" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import videoCard from './videoCard'

  export default {
    name: 'videoCardsSection',
    components: {
      videoCard,
    },
    props: {
      trackIndex: String,
      track: Object,
    }
  }
</script>
<style>
</style>
